import * as THREE from 'three';

export { Scene } from './Scene.js';
export { Tank } from './Tank.js';
export { Airplane } from './Airplane.js';
export { Player } from './Player.js';
export { Sniper } from './Sniper.js';
export { RocketLauncher } from './RocketLauncher.js';
export { Turret } from './Turret.js';
export { Barracks } from './Barracks.js';
export { BuyZone } from './BuyZone.js';
export { HealthPack } from './HealthPack.js';
export { Projectile } from './Projectile.js';
export { Explosion } from './Explosion.js';
export { Obstacle } from './Obstacle.js';

// The original look of the game
export const id = 'classic';
export const icon = '🎮';
export const name = 'Classic';

export function configureRenderer(renderer) {
  renderer.toneMapping = THREE.NoToneMapping;
  renderer.setClearColor(0x080a14);
}

// Called on every entity's root object after it is built
export function prepare() {}

export const strings = {
  subtitle: 'Real-time 3D multiplayer strategy',
  about: 'Arena Game is a real-time 3D multiplayer strategy game where two players battle for supremacy using tanks, helicopters, and turrets.',
  units: {
    tank: 'Tank',
    airplane: 'Helicopter',
    super_tank: 'Super Tank',
    super_helicopter: 'Super Helicopter',
    sniper: 'Sniper',
    rocket_launcher: 'Rocket Launcher'
  },
  iconTank: '🚗',
  iconHelicopter: '🚁',
  tanks: 'Tanks',
  helicopters: 'Helicopters',
  money: amount => `$${amount}`,
  notEnoughMoney: 'Not enough money',
  buy: 'buy',
  waitingToSpawn: 'waiting to spawn...',
  forwardBase: 'Forward Base',
  turret: 'Turret',
  barracks: 'Barracks',
  shoot: 'Shoot',
  buyClaim: 'Buy/Claim',
  bulkBuy: 'Bulk buy (10 units)',
  bulkBuyShort: 'Bulk buy (10)',
  statTanks: 'Tanks',
  statHelicopters: 'Helicopters',
  statSnipers: 'Snipers',
  statRockets: 'Rockets',
  statTurrets: 'Turrets',
  statBarracks: 'Barracks',
  statPlayer: 'Player'
};

export const messages = [];
